<template lang="pug">
div(:class="{ 'myanmar-login': myanmarLogin }")
  .bg-login(data-id="login-cover-image")
    .page-container.modal-dialog-centered.mx-auto.my-0(style="max-width: 500px;padding: 0 8px;")
      .login.login-v2.w-100.mx-auto(data-pageload-addclass='animated fadeIn')
        .user-wrap
          i.fas.fa-user
        .login-header
          .brand.text-yellow.text-center.text-uppercase
            b {{ $t("ui.combine.reset_password") }}
        .login-content
          b-form.margin-bottom-0(@submit.stop.prevent="submit" novalidate :disabled="!submission.success")
            .form-group.m-b-20
              b-input-group.input-group-sm
                DebounceInput(
                  :type=" (isOPWShown) ? 'password' : 'text'"
                  ref="old_password"
                  :dirty="$v.old_password.$dirty"
                  :error="$v.old_password.$error"
                  :placeholder='$t("ui.old_password")'
                  v-model.trim.lazy="$v.old_password.$model"
                  :maxLength="$v.old_password.$params.maxLength.max"
                  :disabled="loading"
                )
                .input-group-append(style="cursor: pointer;")
                  b-button.btn.btn-outline-secondary.btn-sm(:pressed.sync="isOPWShown" style="border-top-right-radius: 6px;border-bottom-right-radius: 6px;")
                    i.fa(:class=" (isOPWShown) ? 'icon-eye-open fa-eye' : 'icon-eye-close fa-eye-slash'")
                ValidateResult(:value="$v.old_password" :name="$t('ui.old_password')")
            .form-group.m-b-20
              b-input-group.input-group-sm
                DebounceInput(
                  :type=" (isPWShown) ? 'password' : 'text'"
                  ref="new_password"
                  :dirty="$v.new_password.$dirty"
                  :error="$v.new_password.$error"
                  :placeholder='$t("ui.new_password")'
                  v-model.trim.lazy="$v.new_password.$model"
                  :maxLength="$v.new_password.$params.maxLength.max"
                  :disabled="loading"
                )
                .input-group-append(style="cursor: pointer;")
                  b-button.btn.btn-outline-secondary.btn-sm(:pressed.sync="isPWShown" style="border-top-right-radius: 6px;border-bottom-right-radius: 6px;")
                    i.fa(:class=" (isPWShown) ? 'icon-eye-open fa-eye' : 'icon-eye-close fa-eye-slash'")
                ValidateResult(:value="$v.new_password" :name="$t('ui.new_password')")
            .form-group.m-b-20
              b-input-group.input-group-sm
                DebounceInput(
                  :type=" (isCPWShown) ? 'password' : 'text'"
                  ref="confirm_password"
                  :dirty="$v.confirm_password.$dirty"
                  :error="$v.confirm_password.$error"
                  :placeholder='$t("ui.confirm_password")'
                  v-model.trim.lazy="$v.confirm_password.$model"
                  :disabled="loading"
                )
                .input-group-append(style="cursor: pointer;")
                  b-button.btn.btn-outline-secondary.btn-sm(:pressed.sync="isCPWShown" style="border-top-right-radius: 6px;border-bottom-right-radius: 6px;")
                    i.fa(:class=" (isCPWShown) ? 'icon-eye-open fa-eye' : 'icon-eye-close fa-eye-slash'")
                ValidateResult(:value="$v.confirm_password" :name="$t('ui.confirm_password')" :name2="$t('ui.new_password')")
            .form-group.m-b-20
              DebounceInput(
                required
                type="text"
                autocomplete="off"
                v-model.trim.lazy="$v.security_tag.$model"
                :placeholder='$t("ui.security_tag")'
                :disabled="loading"
                :dirty="$v.security_tag.$dirty"
                :error="$v.security_tag.$error"
                :maxLength="$v.security_tag.$params.maxLength.max"
              )
              ValidateResult(:value="$v.security_tag" :name="$t('ui.security_tag')")
            .form-group.m-b-20
              DebounceInput(
                required
                type="text"
                ref="security_code"
                autocomplete="off"
                v-model.trim.lazy="$v.security_code.$model"
                :placeholder='$t("ui.security_code")'
                :disabled="loading"
                :dirty="$v.security_code.$dirty"
                :error="$v.security_code.$error"
                :maxLength="$v.security_code.$params.maxLength.max"
              )
              ValidateResult(:value="$v.security_code" :name="$t('ui.security_code')")
            .form-group.m-b-20
              DebounceInput(
                required
                type="text"
                autocomplete="off"
                v-model.trim.lazy="$v.confirm_security_code.$model"
                :placeholder='$t("ui.confirm_security_code")'
                :disabled="loading"
                :dirty="$v.confirm_security_code.$dirty"
                :error="$v.confirm_security_code.$error"
                )
              ValidateResult(:value="$v.confirm_security_code" :name="$t('ui.confirm_security_code')" :name2="$t('ui.security_code')")
            .form-group.m-b-20
              b-alert.text-center.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
            .login-buttons
              SubmitButton.btn.btn-block.btn-lg(:loading="loading" icon="fa fa-times" :text="$t('ui.reset')" isModal=false type="button"  @click="clear()")
              SubmitButton.btn.btn-block.btn-lg(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=false type="button" @click="resetPasswordPost()")
</template>

<script>
import config from "@/config";
import { required, minLength, maxLength, sameAs, helpers } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";


export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      isOPWShown: true,
      isPWShown: true,
      isCPWShown: true,
      old_password: "",
      new_password: "",
      confirm_password: "",
      security_tag: "",
      security_code: "",
      confirm_security_code: "",
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      redirect: "/settings"
    }
  },
  validations: {
    old_password: {
      required,
      maxLength: maxLength(50)
    },
    new_password: {
      required,
      valid: function(value) {
        return this.$helpers.passwordFormat(value);
      },
      notSame: function(value) {
        return value != this.old_password;
      },
      minLength: minLength(8),
      maxLength: maxLength(50)
    },
    confirm_password: {
      required,
      sameAs: sameAs('new_password')
    },
    security_tag: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    security_code: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    confirm_security_code: {
      required,
      sameAs: sameAs("security_code")
    }
  },
  computed: {
    myanmarLogin() {
      return config.myanmarLogin;
    }
  },
  mounted () {
    this.$refs.old_password.$el.focus();
  },
  methods: {
    reset: function() {
      this.$v.$reset()
      this.submission.success = true
      this.submission.status = ""
    },
    clear: function() {
      this.old_password = ""
      this.new_password = ""
      this.confirm_password = ""
      this.security_tag = ""
      this.security_code = ""
      this.confirm_security_code = ""
      this.$nextTick(() => {
        this.reset()
      });
    },
    resetPasswordPost: function() {
      this.reset()
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_account_password_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            let password = this.old_password
            let new_password = this.new_password
            let security_tag = this.security_tag
            let security_code = this.security_code
            this.$store
              .dispatch("user/resetPasswordPost", { password, new_password, security_tag, security_code })
              .then(response => {
                this.loading = false
                this.submission.success = response.success
                this.submission.status = response.errorTag
                this.$swal({
                  title: this.$t("ui.succeed"),
                  text: this.$t("message.update_account_password_success"),
                  type: "success",
                  allowOutsideClick: false
                }).then(isConfirm => {
                  if (isConfirm) {
                    //this.cancel();
                    this.$router.push("/settings")
                  }
                });
              })
              .catch(response => {
                this.loading = false
                this.submission.success = response.success
                this.submission.status = this.$t("message." + response.errorTag);
              });
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_account_password_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    cancel: function() {
      this.clear()
      this.$router.push("/")
    }
  }
}
</script>
